<template>
    <div class="d-flex align-center grey lighten-3 px-5 py-5 mb-3 rounded-lg">
      <v-switch
        v-model="showExtraHeaders"
        @change="setShowExtraHeaders"
        :label="$t('appointment.table.showExtraFields')"
        class="table-switch my-2"
        hide-details
        dense
        inset
      />
      <div v-if="selectedAppointments.length >= 1" class="d-flex">
        <v-divider class="mx-3 my-1" vertical />
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" color="primary" elevation="0" outlined>
              <h5>
                {{ $t('mapDrawing.bulkActions') }}
              </h5>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="openModal('BULK_CANCEL_MODAL')" link>
              <v-icon class="mr-3 grey--text text--lighten-1" style="transform: scale(0.85); opacity: 0.75">
                mdi-calendar-remove-outline
              </v-icon>
              <span class="body-2">
                {{ $t('mapDrawing.cancelOrRemoveFromGroup') }}
              </span>
            </v-list-item>
            <v-list-item @click="openModal('BULK_RESCHEDULE_MODAL')" link>
              <v-icon class="mr-3 grey--text text--lighten-1" style="transform: scale(0.85); opacity: 0.75">
                mdi-calendar-clock
              </v-icon>
              <span class="body-2">
                {{ $t('mapDrawing.reschedule') }}
              </span>
            </v-list-item>
            <v-list-item @click="openModal('BULK_SEND_CONFIRMATION_EMAIL_MODAL')" link>
              <v-icon class="mr-3 grey--text text--lighten-1" style="transform: scale(0.85); opacity: 0.75">
                mdi-email-check-outline
              </v-icon>
              <span class="body-2">
                {{ $t('mapDrawing.sendConfirmationEmail') }}
              </span>
            </v-list-item>
            <v-list-item @click="openModal('BULK_SEND_REJECTED_EMAIL_MODAL')" link>
              <v-icon class="mr-3 grey--text text--lighten-1" style="transform: scale(0.85); opacity: 0.75">
                mdi-email-remove-outline
              </v-icon>
              <span class="body-2">
                {{ $t('mapDrawing.sendRejectedEmail') }}
              </span>
            </v-list-item>
            <v-list-item @click="openModal('BULK_CHANGE_APPOINTMENT_STATUS_MODAL')" link>
              <v-icon class="mr-3 grey--text text--lighten-1" style="transform: scale(0.85); opacity: 0.75">
                mdi-flag-outline
              </v-icon>
              <span class="body-2">
                {{ $t('mapDrawing.changeAppointmentStatus') }}
              </span>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'AppointmentListShowExtraContent',

    props: {
      selectedAppointments: {
        type: Array,
        required: true,
      },
    },

    methods: {
      ...mapActions(['openModal']),

      setShowExtraHeaders(value) {
        this.$emit('setShowExtraHeaders', value)
      },
    },

    data() {
      return {
        showExtraHeaders: false,
      }
    },
  }
</script>
